export default __webpack_public_path__ + "static/media/icon_search_gray.801f8a36.svg";